import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { SubscriptionTiersService } from '@galaxy/partner';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';
import { TrialStatus } from '../../core/partner/partner-trial-status';
import { PartnerTrialStoreService } from '../../partner-trial';
import { SupportNumberService } from './support-phone.service';

/**
 * Usage:
 *
 * <your-component [matMenuTriggerFor]="helpMenu?.contextMenu"></your-component>
 * <app-help-menu #helpMenu [accountExecutiveEmail]="accountExecutive"></app-help-menu>
 */
@Component({
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatIconModule, TranslateModule],
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
})
export class HelpMenuComponent implements OnInit {
  @ViewChild('contextMenu', { read: MatMenu, static: true }) public contextMenu: MatMenu;

  @Input() accountExecutiveEmail: string;
  @Input() yPosition: 'below' | 'above' = 'below';
  @Input() xPosition: 'before' | 'after' = 'after';
  @Input() shouldDisplayInstantDemo = true;
  supportNumber$: Observable<string>;
  isFreePartner$: Observable<boolean>;
  trialActive$: Observable<boolean>;

  constructor(
    private trialService: PartnerTrialStoreService,
    private supportNumberService: SupportNumberService,
    private partnerService: PartnerService,
  ) {}

  ngOnInit(): void {
    this.trialActive$ = this.trialService.partnerTrial$.pipe(map((t) => t.status === TrialStatus.ACTIVE));
    this.isFreePartner$ = this.partnerService.subscriptionTier$.pipe(map((s) => SubscriptionTiersService.isFree(s)));
    this.supportNumber$ = this.supportNumberService.getSupportNumber();
  }

  openResourceCenter(): void {
    window.open('https://support.vendasta.com', '_blank');
  }
}
